import { request } from '@umijs/max';
import type { Dayjs } from 'dayjs';


export namespace EnquiryApi {
  /** 询价记录信息 */
  export interface Enquiry {
    id: number; // id
    userId: number; // 外键 用户ID
    carsId: number; // 外键 询价车辆ID
    status: number; // 处理状态 0=未处理 1=已处理
    workId: number; // 处理人ID ，从系统用户表查询
    workTime: string | Dayjs; // 处理时间
    askName: string; // 询价人姓名
    workName: string; // 询价人姓名
    carName: string; // 询价人姓名
    carBelongToName: string; // 询价人姓名
    askPhone: string; // 询价人联系电话
    brandName: string; // 询价人联系电话
    askAddrSelect: Array<any>; // 询价人地址 大区
    askAddrRegion: string; // 询价人地址 大区
    askAddrProvince: string; // 询价人地址 省
    askAddrCity: string; // 询价人 市
    askAddrCounty: string; // 询价人 县
    remark: string; // 备注
  }
  export interface PageInfo {
    total?: number;
    list?: Array<Enquiry>;
  }
  export interface ResultPage {
    code: number;
    msg: string;
    data?: PageInfo;
  }
  export interface CountResultPage {
    code: number;
    msg: string;
    data?: number;
  }
}

/** 查询询价记录分页 */
export async function getEnquiryPage(options?: { [key: string]: any }) {
  return request<EnquiryApi.ResultPage>('/admin-api/admin/enquiry/page',{
    method: 'GET',
    params: options,
  });
}

/** 查询询价记录分页 */
export async function getRv2goOrderPage(options?: { [key: string]: any }) {
  return request<EnquiryApi.ResultPage>('/admin-api/admin/rv2goOrder/page',{
    method: 'GET',
    params: options,
  });
}
/** 查询询价记录详情 */
export async function getEnquiry(id: number) {
  return request<EnquiryApi.Enquiry>(`/admin-api/admin/enquiry/get?id=${id}`,{
    method: 'GET',
  });
}

/** 查询询价记录详情 */
export async function getNoReadCount() {
  return request<EnquiryApi.CountResultPage>(`/admin-api/admin/enquiry/getNoReadCount`,{
    method: 'GET',
  });
}

/** 新增询价记录 */
export async function createEnquiry(data: EnquiryApi.Enquiry) {
  return request('/admin-api/admin/enquiry/create', {
    method: 'POST',
    data: data
  });
}

/** 修改询价记录 */
export async function updateEnquiry(data: any) {
  return request('/admin-api/admin/enquiry/update', {
    method: 'PUT',
    data: data
  });
}

/** 删除询价记录 */
export async function deleteEnquiry(id: number) {
  return request(`/admin-api/admin/enquiry/delete?id=${id}`,{
    method: 'DELETE',
  });
}

/** 批量删除询价记录 */
export function deleteEnquiryList(ids: number[]) {
  return request(`/admin-api/admin/enquiry/delete-list?ids=${ids.join(',')}`,{
    method: 'DELETE',
  });
}

/** 导出询价记录 */
export function exportEnquiry(params: any) {
  return request('/admin-api/admin/enquiry/export-excel', {
    method: 'GET',
    params: params
  });
}
/** 新增价记录 */
export function setEnquiry(params: any) {
  return request('/app-api/Enquiry/SetEnquiry', {
    method: 'POST',
    data: params
  });
}


